import React, { useState, useEffect, useRef } from 'react';
import { NavLink } from 'react-router';
import './css/Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const hamburgerRef = useRef(null);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        menuRef.current && !menuRef.current.contains(e.target) &&
        hamburgerRef.current && !hamburgerRef.current.contains(e.target)
      ) {
        setIsMenuOpen(false);
      }
    };

    const handleResize = () => {
      if (window.innerWidth > 767) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('click', handleOutsideClick);
    window.addEventListener('resize', handleResize);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>


      <div className="nav-wrapper">
        <div className="nav-top">
          <div className="logo">
            <img
              src="/walnut-logo.png"
              alt="WALNUT® Industries Logo"
              className="logo-img"
            />
            {/* <div className="logo-text">WALNUT<sup>®</sup></div> */}
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            {/* <div className="nav-icons">
              <div className="nav-icon-btn" title="Search">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              </div>
            </div> */}
            <div
              ref={hamburgerRef}
              className={`hamburger ${isMenuOpen ? 'open' : ''}`}
              onClick={toggleMenu}
              aria-label="Menu"
            >
              <span></span><span></span><span></span>
            </div>
          </div>
        </div>

        {/* DESKTOP ROUTE LINKS */}
        <div className="nav-bottom">
          <div className="nav-bottom-spacer"></div>
          <ul className="nav-links">
            <li>
              <NavLink to="/" className={({ isActive }) => isActive ? 'active' : ''}>Home</NavLink>
            </li>
            <li>
              <NavLink to="/products" className={({ isActive }) => isActive ? 'active' : ''}>Products</NavLink>
            </li>
            <li>
              <NavLink to="/about" className={({ isActive }) => isActive ? 'active' : ''}>About Us</NavLink>
            </li>
            <li>
              <NavLink to="/contact" className={({ isActive }) => isActive ? 'active' : ''}>Contact Us</NavLink>
            </li>
            <li>
              <NavLink to="/exports" className={({ isActive }) => isActive ? 'active' : ''}>Exports</NavLink>
            </li>
          </ul>
         <div className="nav-social">
  {/* LinkedIn */}
  <a
    href="https://www.linkedin.com/in/sahil-garg-6218a558"
    target="_blank"
    rel="noopener noreferrer"
    className="soc-linkedin"
    title="LinkedIn"
    aria-label="LinkedIn"
  >
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
      <path d="M4.98 3.5C4.98 4.88 3.86 6 2.48 6S0 4.88 0 3.5 1.12 1 2.48 1s2.5 1.12 2.5 2.5zM.5 8h4V24h-4V8zm7 0h3.84v2.16h.06c.53-1.01 1.84-2.08 3.79-2.08C19.23 8.08 21 10.29 21 14.29V24h-4v-8.43c0-2.01-.04-4.59-2.8-4.59-2.8 0-3.23 2.19-3.23 4.45V24h-4V8z" />
    </svg>
  </a>

  <a
  href="https://www.facebook.com/profile.php?id=61591319054206"
  target="_blank"
  rel="noopener noreferrer"
  className="soc-fb"
  title="Facebook"
  aria-label="Facebook"
>
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M24 12.07C24 5.4 18.63 0 12 0S0 5.4 0 12.07c0 6.03 4.39 11.03 10.13 11.93v-8.44H7.08v-3.49h3.05V9.41c0-3.03 1.79-4.71 4.53-4.71 1.31 0 2.68.24 2.68.24v2.97h-1.51c-1.49 0-1.95.93-1.95 1.88v2.28h3.33l-.53 3.49h-2.8V24C19.61 23.1 24 18.1 24 12.07z" />
  </svg>
</a>

  {/* Instagram */}
  <a
    href="https://www.instagram.com/walnutindustries_?igsh=ZzdmMnR0OHM2bGwz"
    target="_blank"
    rel="noopener noreferrer"
    className="soc-ig"
    title="Instagram"
    aria-label="Instagram"
  >
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
      <path d="M7.75 2C4.57 2 2 4.57 2 7.75v8.5C2 19.43 4.57 22 7.75 22h8.5C19.43 22 22 19.43 22 16.25v-8.5C22 4.57 19.43 2 16.25 2h-8.5zm0 2h8.5A3.75 3.75 0 0 1 20 7.75v8.5A3.75 3.75 0 0 1 16.25 20h-8.5A3.75 3.75 0 0 1 4 16.25v-8.5A3.75 3.75 0 0 1 7.75 4zm8.75 1a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5zM12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6z" />
    </svg>
  </a>

  {/* WhatsApp */}
  <a
    href="https://wa.me/917814303074"
    target="_blank"
    rel="noopener noreferrer"
    className="soc-whatsapp"
    title="WhatsApp"
    aria-label="WhatsApp"
  >
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
      <path d="M20.52 3.48A11.8 11.8 0 0 0 12.04 0C5.46 0 .11 5.35.11 11.94c0 2.1.55 4.15 1.6 5.96L0 24l6.28-1.65a11.9 11.9 0 0 0 5.76 1.47h.01c6.58 0 11.93-5.35 11.93-11.94 0-3.19-1.24-6.19-3.46-8.4zM12.05 21.8a9.8 9.8 0 0 1-5-1.37l-.36-.21-3.73.98 1-3.64-.24-.37a9.82 9.82 0 1 1 8.33 4.61zm5.39-7.34c-.29-.14-1.71-.84-1.98-.93-.26-.1-.45-.14-.64.14-.19.29-.74.93-.91 1.12-.17.19-.33.21-.62.07-.29-.14-1.21-.45-2.31-1.44-.85-.76-1.43-1.7-1.59-1.98-.17-.29-.02-.44.12-.58.13-.13.29-.33.43-.5.14-.17.19-.29.29-.48.09-.19.05-.36-.02-.5-.07-.14-.64-1.55-.88-2.12-.23-.56-.47-.48-.64-.49h-.55c-.19 0-.5.07-.76.36-.26.29-1 1-.99 2.43 0 1.43 1.03 2.81 1.17 3 .14.19 2.02 3.08 4.89 4.32.68.29 1.21.46 1.63.59.68.22 1.3.19 1.79.12.55-.08 1.71-.7 1.95-1.38.24-.69.24-1.28.17-1.4-.07-.12-.26-.19-.55-.33z" />
    </svg>
  </a>
</div>
        </div>
      </div>

      {/* MOBILE DRAWER ROUTE LINKS */}
      <div ref={menuRef} className={`mobile-menu ${isMenuOpen ? 'open' : ''}`}>
        <NavLink to="/" className={({ isActive }) => isActive ? 'active' : ''} onClick={() => setIsMenuOpen(false)}>Home</NavLink>
        <NavLink to="/products" className={({ isActive }) => isActive ? 'active' : ''} onClick={() => setIsMenuOpen(false)}>Products</NavLink>
        <NavLink to="/about" className={({ isActive }) => isActive ? 'active' : ''} onClick={() => setIsMenuOpen(false)}>About Us</NavLink>
        <NavLink to="/contact" className={({ isActive }) => isActive ? 'active' : ''} onClick={() => setIsMenuOpen(false)}>Contact Us</NavLink>
        <NavLink to="/exports" className={({ isActive }) => isActive ? 'active' : ''} onClick={() => setIsMenuOpen(false)}>Exports</NavLink>
      </div>
    </>
  );
};

export default Navbar;